var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tank-info"},[(_vm.level != null)?_c('div',{style:({ color: _vm.fontColor })},[_vm._v("\n    "+_vm._s(_vm.level)+"m\n  ")]):_c('div',[_vm._v("\n    - m\n  ")]),(_vm.tonn != null)?_c('div',[_vm._v("\n    "+_vm._s(_vm.tonn)+"t\n  ")]):_c('div',[_vm._v("\n    - t\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }